import script from "./MoviesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MoviesView.vue?vue&type=script&setup=true&lang=js"

import "./MoviesView.vue?vue&type=style&index=0&id=0b61c68c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b61c68c"]])

export default __exports__